import { createAsyncThunk } from '@reduxjs/toolkit';
import { initializeAblyChatForCopilotV2 } from '../api/chatApi';
// initializes an Ably channel and creates a new thread
export const initializeAblyChannel = createAsyncThunk('chat/initializeAblyChannel', async ({
  assistantType,
  customCopilotId
} = {}) => {
  const response = await initializeAblyChatForCopilotV2({
    customCopilotId
  });
  return Object.assign({}, response, {
    thread: Object.assign({}, response.thread, {
      assistantType
    })
  });
});